// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';

@Injectable()
export class LMListContentFilterListService {

  constructor(private lmFormatUtilService: LMFormatUtilService) { }

  public getFilterListTemplateData(dataViewSet: LMDataViewSet, groupLabelSpec: LMRelatedValueSpec): Array<LMFilterListTemplateData> {
    const accordionItems: LMFilterListTemplateData[] = [];

    for (let i = 0; i < dataViewSet.data.length; i++) {
      const dataView: LMDataView = dataViewSet.data[i];

      const accordionItem: LMFilterListTemplateData = {};

      const groupedLabel: string = this.getGroupLabelValue(dataView, groupLabelSpec);
      if (groupedLabel) {
        accordionItem.item = groupedLabel;
        accordionItem.groupItems = this.getGroupedItems(dataViewSet, groupedLabel, groupLabelSpec, i);
        i += accordionItem.groupItems.length - 1;
      } else {
        accordionItem.item = dataView;
        accordionItem.groupItems = null;
        accordionItem.index = i;
      }

      accordionItems.push(accordionItem);
    }

    return accordionItems;
  }

  private getGroupedItems(dataViewSet: LMDataViewSet, groupLabel: string, groupLabelSpec: LMRelatedValueSpec, i: number): LMFilterListTemplateData[] {
    const accordionItems: LMFilterListTemplateData[] = [];

    for (; i < dataViewSet.data.length; i++) {
      const dataView: LMDataView = dataViewSet.data[i];
      if (groupLabel !== this.getGroupLabelValue(dataView, groupLabelSpec)) {
        break;
      }

      accordionItems.push({ item: dataView, index: i });
    }

    return accordionItems;
  }

  private getGroupLabelValue(data: LMDataView, groupLabel: LMRelatedValueSpec): string {
    const groupLabelFieldId = groupLabel.fieldId;
    const groupField: LMField = data.fields[groupLabelFieldId];
    const value = this.lmFormatUtilService.stateLabelToText(groupField.stateValues, String(groupField.value));
    return (value.trim().length) ? value : null;
  }
}
